import { Dispatch, SetStateAction, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { StatusFigurant } from 'models';

import { TYPES_ACTION } from './@types';
import { typeAnimalFigurant, typeChildFigurant, typeVehicleFigurant } from '../FigurantCard/constants';
import { KeySrcTypes } from '../FigurantCard/@types';

type KeySrcTypesWithoutSearch = Exclude<KeySrcTypes, 'SEARCH'>;
type Props = {
  currentStep?: number;
  totalFigurant?: number;
  selectedFigurant: StatusFigurant[];
  setSelectedFigurant: Dispatch<SetStateAction<StatusFigurant[]>>;
  typeAction: KeySrcTypesWithoutSearch;
  handleNext: () => void;
  type: string;
  hasMissingFigurant?: boolean;
};

export const useSelectedFigurantsModal = ({
  currentStep,
  totalFigurant = 0,
  selectedFigurant,
  setSelectedFigurant,
  typeAction,
  handleNext,
  type = '1',
  hasMissingFigurant,
}: Props) => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(prev => !prev);
  };
  const removeFigurant = ({ id }: { id: number }) => {
    setSelectedFigurant(selectedFigurant.filter(figurant => figurant.id !== id));
  };

  const ExpandIcon = open ? KeyboardArrowDownIcon : KeyboardArrowUpIcon;

  const dataByTypeAction: Record<KeySrcTypesWithoutSearch, { textAction: string; onClickNext: () => void }> = {
    [TYPES_ACTION.CLIMBED]: {
      textAction: 'escalado(s)',
      onClickNext: () => {
        const allowedTypes = [typeChildFigurant, typeVehicleFigurant, typeAnimalFigurant];

        if (type === typeChildFigurant) {
          handleNext?.();
          return;
        }

        if (!hasMissingFigurant && allowedTypes.includes(type)) {
          setOpen(false);
        }

        if (totalFigurant < selectedFigurant.length) {
          setOpen(false);
          return;
        }

        handleNext?.();
      },
    },
    [TYPES_ACTION.LICENSE]: {
      textAction: 'associado(s)',
      onClickNext: handleNext,
    },
  };

  const textAction = dataByTypeAction[typeAction].textAction;
  const onClickNext = dataByTypeAction[typeAction].onClickNext;

  const withoutFigurantSelected = selectedFigurant?.length < 1;

  const showAlertToFiscal =
    hasMissingFigurant &&
    withoutFigurantSelected &&
    (type === typeChildFigurant || type === typeVehicleFigurant || type === typeAnimalFigurant);

  const showAlert = {
    [TYPES_ACTION.CLIMBED]:
      (hasMissingFigurant && !open) || showAlertToFiscal || totalFigurant < selectedFigurant.length,
    [TYPES_ACTION.LICENSE]: true,
  };

  const showAlertOpened = {
    [TYPES_ACTION.CLIMBED]: open && currentStep === 1 && hasMissingFigurant,
    [TYPES_ACTION.LICENSE]: false,
  };

  return {
    toggleDrawer,
    removeFigurant,
    ExpandIcon,
    textAction,
    onClickNext,
    showAlert,
    showAlertOpened,
    open,
  };
};
